import type { Menu } from '#/global'

const menus: Menu.recordRaw = {
  path: '/link/list',
  meta: {
    title: '链接列表',
    icon: 'i-ep:list',
  },
}

export default menus
